import { render, staticRenderFns } from "./WXCW81JDQBD.vue?vue&type=template&id=0248e7b4&"
import script from "./WXCW81JDQBD.vue?vue&type=script&lang=js&"
export * from "./WXCW81JDQBD.vue?vue&type=script&lang=js&"
import style0 from "./WXCW81JDQBD.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports